import { buildSearchParamsKey } from 'lib/search/searchUtils'

/** Keep existing keys for ungrouped quotes; group-specific surcharges cannot share them. */
export default function buildOfferBestPriceKey(
  checkIn?: string,
  checkOut?: string,
  rooms?: Array<App.Occupants>,
  bundledOfferId?: string,
  lereGroup?: string,
): string {
  const searchKey = buildSearchParamsKey(checkIn, checkOut, rooms, bundledOfferId)
  return lereGroup ? `${searchKey}-lere:${lereGroup}` : searchKey
}
